<script setup lang='ts'>
import { cityName, provinceName } from '@qctsw/common'
import { logicCollectiveRelativeComplaintList } from '~/logic/complaint/collective'

const props = withDefaults(defineProps<{
  dataId?: string
  brandStrs?: string
  seriesStrs?: string
  complainCount?: number
}>(), {
  dataId: '',
})

function formatAreaStr(pid: string | null, cid: string | null) {
  const strs = [pid ? provinceName(pid, '', true) : null, cid ? cityName(cid, '', true) : null].filter(v => v)
  const str = Array.from(new Set(strs)).join('')
  return (str || '-')
}
const {
  data,
  pagination,
  getPage,
  state,
} = logicCollectiveRelativeComplaintList()

await getPage(1, { collectiveId: props.dataId })
</script>

<template>
  <div v-if="dataId">
    <div class="flex items-center mb-4">
      <BasicTitle class="h-7" />
      <div>
        <span class="font-bold text-red-5">
          {{ `${brandStrs}(${seriesStrs})` }}
        </span>
        <span class="font-bold">集体投诉 共{{ complainCount }}宗</span>
      </div>
    </div>
    <template v-if="complainCount">
      <n-watermark content="汽车投诉网" :font-size="13" :width="150" :height="100" font-color="#f1f5f9" :x-offset="20" :y-offset="50" :rotate="-10">
        <div class="header relative grid grid-cols-2 bg-slate-2 rounded-1.5">
          <div v-for="v in 2" :key="v" class=" px-2.5 py-2.5 text-info header-item flex items-center justify-between">
            <div>投诉编号</div>
            <div>姓名</div>
            <div>城市</div>
          </div>
        </div>
        <div class="grid grid-cols-2 z-99 relative">
          <NuxtLink
            v-for="v in data" :key="v.carComplainId"
            :to="`/complaint/detail/${v.carComplainId}`" target="_blank"
            class="px-2.5 py-4 list-item flex items-center justify-between hover:text-orange-6"
          >
            <div>QT{{ v.carComplainId }}</div>
            <div class="line-clamp-1 flex items-center justify-center">
              <span>{{ v.carUserName.slice(0, 1) }}</span>
              <span>{{ v?.userSex === 2 ? '女士' : '先生' }}</span>
            </div>
            <div v-if="formatAreaStr(v.portalUserProvinceId?.toString(), v.portalUserCityId?.toString())" class>
              {{ formatAreaStr(v.portalUserProvinceId?.toString(), v.portalUserCityId?.toString()) }}
            </div>
          </NuxtLink>
        </div>
      </n-watermark>
      <div class="relative">
        <BasicLoadButton class="more" :state="state" @load="() => getPage(pagination.pagination.page, { collectiveId: props.dataId })" />
        <span class="tips">数据来源：汽车投诉网</span>
      </div>
    </template>
    <div v-else class="w-50 ma">
      <BasicEmpty />
    </div>
  </div>
</template>

<style lang='scss' scoped>
.more {
  --uno: relative w-full bg-slate-2 py-2 mt-xs text-center rounded-1.5  text-3.5 text-info cursor-pointer ;

}
.tips {
    --uno: absolute right-4 bottom-2 text-slate-5 text-3;
  }
.list-item,
.header-item {
  --uno: border-r-1 border-slate-2;

  &:nth-child(2n) {
    border-right-color: transparent;
  }

  &>div {
    text-align: center;
  }

  &>div:nth-child(1) {
    width: 85px;
    flex-shrink: 0;
  }

  &>div:nth-child(2) {
    width: 80px;
    flex-shrink: 0;
  }

  &>div:nth-child(3) {
    width: 120px;
  }
}
.list-item {
  --uno: border-b-1 border-slate-2;
  // &:nth-child(odd):last-child,
  // &:nth-child(even):last-child {
  //   border-bottom-color: transparent;
  // }
}
</style>
